import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { CRTemplateProps } from "./crTemplate";
import React from "react";
export default class CrMachineMaterialApp extends React.Component<CRTemplateProps, any> {
    common = new AppHelper();
    notificationHelper: NotificationHelper = new NotificationHelper();
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    save = (closeAfterSave) => {
        const saveText = this.props.context["saveText"];
        if (saveText) {
            saveText();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        this.common.setEntityDirtyState(Helper.hasValue(value));
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });

        return <CommonApp {...props} />;
    }
}